// @ngInject
function AnalysisApiService($q, $window, DS, ResourcesService, DSHttpAdapter) {

    var endpoint = 'analysis';

    return {
        getReports: ResourcesService.apiFactory.get(endpoint + '/getReports'),
        saveReport: saveReport,
        getDataSources: ResourcesService.apiFactory.get(endpoint + '/getDataSources'),
        getUserReports: ResourcesService.apiFactory.get(endpoint + '/getUserReports'),
        saveUserReport: saveUserReport,
        deleteUserReport: deleteUserReport,
        getSharedReports: ResourcesService.apiFactory.get(endpoint + '/getSharedReports'),
        getPdfTemplates: ResourcesService.apiFactory.get(endpoint + '/getPdfTemplates'),
        savePdfTemplate: savePdfTemplate,
        getReportGroups: ResourcesService.apiFactory.get(endpoint + '/getReportGroups'),
        saveUserReportSortOrder: saveUserReportSortOrder,
        getLocalization: ResourcesService.apiFactory.get(endpoint + '/getLocalization'),
        getUserReportsToConvert: ResourcesService.apiFactory.get(endpoint + '/getUserReportsToConvert'),
        saveConvertedUserReport: saveConvertedUserReport,
        getLocations: ResourcesService.apiFactory.get(endpoint + '/locations')
    };

    function saveReport(report) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'analysis/saveReport', report).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function saveUserReport(userReport) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'analysis/saveUserReport', userReport).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function deleteUserReport(userReport) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'analysis/deleteUserReport', userReport).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function savePdfTemplate(pdfTemplate) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'analysis/savePdfTemplate', pdfTemplate).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function saveUserReportSortOrder(reports) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'analysis/updateUserReportSortOrder', reports).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }

    function saveConvertedUserReport(userReport) {
        var deferred = $q.defer();
        DSHttpAdapter.PUT(DS.defaults.basePath + 'analysis/saveConvertedUserReport', userReport).then(function (response) {
            deferred.resolve(response);
        }, function (error) {
            deferred.reject(error);
        });

        return deferred.promise;
    }
}

angular.module('analysis.api', [])
  .factory('AnalysisApiService', AnalysisApiService);
